<template>
    <b-modal v-model="modal_raw_materials.show"
             centered
             title="Materias primas"
             size="lg"
             hide-footer
             dialog-class="calculator-dialog"
    >
        <!-- Filtros -->
        <b-row>
            <!-- Nombre -->
            <b-col lg="5"
                   md="6"
                   class="mb-1"
            >
                <el-input id="name"
                          name="name"
                          size="small"
                          type="text"
                          v-model="modal_raw_materials.params.name"
                          placeholder="Filtrar por nombre de la materia prima"
                />
            </b-col>

            <!-- Botones -->
            <b-col lg="7"
                   md="6"
                   class="text-nowrap pl-lg-0 mb-1 mt-md-0 mt-1"
            >
                <b-button-group size="md">
                    <b-button @click="getRawMaterials(true)"
                              variant="primary"
                              size="sm"
                    >
                        <i class="fa fa-search fa-lg"></i>
                        Buscar
                    </b-button>
                    <b-button @click="resetParamsInModalRawMaterials()"
                              size="sm"
                    >
                        <i class="fa fa-eraser fa-lg"></i>
                        Limpiar
                    </b-button>

                </b-button-group>

                <b-button variant="primary"
                          class="float-right"
                          size="sm"
                          @click="openModalForCreation"
                >
                    <i class="fa fa-plus"></i> Crear
                </b-button>
            </b-col>
        </b-row>

        <!-- Tabla -->
        <b-row class="mt-2">
            <b-col class="raw_materials">
                <b-table responsive
                         hover
                         thead-class="table-active"
                         show-empty
                         empty-text="No hay materias primas para mostrar"
                         :items="raw_materials.data"
                         :fields="columns"
                         ref="table"
                >
                    <template #cell(name)="row">
                        <span v-bind:class="{'font-weight-bold': row.index === expanded_row_index}"                        >
                            {{ row.item.name.toUpperCase() }}
                        </span>
                    </template>

                    <template #cell(detail)="row">
                        <b-badge variant="primary"
                                 class="ml-2 cursor-pointer font-weight-light"
                                 @click="_getRawMaterialTemp(row, row.index)"
                        >
                            {{ row.item.components.length }} Componentes
                        </b-badge>
                    </template>

                    <template #cell(show_details)="row">
                        <b-button size="sm"
                                  @click="getRawMaterialForAddition(row)"
                                  class="mr-2 float-right"
                                  variant="primary"
                        >
                            <i class="fa fa-check"/> Seleccionar
                        </b-button>
                    </template>

                    <template #row-details="row">
                        <b-card no-body>
                            <b-list-group v-if="row.item.components && row.item.components.length">
                                <b-list-group-item v-for="c in row.item.components">
                                    <b-row>
                                        <b-col>
                                            <el-tooltip effect="dark"
                                                        placement="top"
                                                        content="Porcentaje reportado"
                                                        popper-class="py-1 px-2 float-right"
                                            >
                                                <b-badge variant="success"
                                                         class="float-right"
                                                >
                                                    {{ c.reported_percentage }}%
                                                </b-badge>
                                            </el-tooltip>
                                            <h6 class="font-weight-bold">
                                                <i class="fa fa-cube"/>
                                                {{ c.component.cas_number }} -
                                                {{ c.component.name.toUpperCase() }}
                                            </h6>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="c.component.sga_categories.length">
                                        <b-col cols="3"
                                               class="mt-1 px-2"
                                               v-for="sga in c.component.sga_categories"
                                        >
                                            <el-tooltip effect="dark"
                                                        placement="bottom"
                                                        :content="sga.category.codigo +  ' - ' + sga.category.categoria"
                                                        popper-class="py-1 px-2 float-right "
                                            >
                                                <b-badge variant="light"
                                                         style="color: rgb(0 132 178); background-color: #fff"
                                                         class="w-100 text-truncate mr-2 font-weight-light border border-primary cursor-pointer"
                                                >
                                                    {{ sga.category.codigo }} - {{ sga.category.categoria }}
                                                </b-badge>
                                            </el-tooltip>
                                        </b-col>
                                    </b-row>
                                    <b-row v-else>
                                        <b-col>
                                            CLASIFICACIÓN SGA NO REPORTADA
                                        </b-col>
                                    </b-row>
                                </b-list-group-item>
                            </b-list-group>
                            <b-list-group v-else>
                                <b-list-group-item>
                                    <b-row>
                                        <b-col class="text-center text-muted">
                                            No hay componentes para mostrar
                                        </b-col>
                                    </b-row>
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </template>
                </b-table>
                <el-pagination class="float-right"
                               v-model="modal_raw_materials.params.page"
                               :total="raw_materials.total"
                               :page-sizes="[10, 20]"
                               :current-page.sync="modal_raw_materials.params.page"
                               :page-size.sync="modal_raw_materials.params.per_page"
                               layout="total,sizes, prev, pager, next"
                               @size-change="getRawMaterials(true)"
                               @current-change="getRawMaterials()"
                />
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal_raw_materials',
    data() {
        return {
            expanded_row_index: null,
            columns: [
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'detail',
                    label: ''
                },
                {
                    key: 'show_details',
                    label: '',
                    thStyle: 'width: 180px; max-width:180px'
                }
            ]
        };
    },
    computed: {
        ...mapState('calculator', [
            'modal_raw_materials',
            'raw_materials',
            'action_raw_material',
            'filters',
            'product',
            'raw_material_temp',
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getRawMaterials',
            'getRawMaterial'
        ]),
        ...mapMutations('calculator', [
            'resetParamsInModalRawMaterials',
            'setFilters',
            'resetRawMaterial',
            'setStepToModalWizard',
            'setActionRawMaterialShow',
            'setShowToModalWizard',
            'setShowToModalRawMaterials',
            'setActionToModalRawMaterial',
            'setRawMaterial',
            'setShowToModalRawMaterial'
        ]),
        async _getRawMaterialTemp(row, index) {
            this.raw_materials.data.forEach((item, i) => {
                if (i !== index && item._showDetails) {
                    item._showDetails = false;
                }
            });

            row.toggleDetails();

            this.expanded_row_index = index;
        },
        async getRawMaterialForAddition(row) {
            let raw_material = {
                id: null,
                cal_product_id: this.product.id,
                name: row.item.name,
                percentage: 0,
                components: []
            };

            row.item.components.forEach(c => {
                let component = c.component

                component.reported_percentage = c.reported_percentage;
                component.final_percentage = 0;
                component.omit_in_composition = false;
                component.omit_in_carcinogens = false;

                raw_material.components.push(component);
            })

            this.setRawMaterial(JSON.parse(JSON.stringify(raw_material)));
            this.setActionToModalRawMaterial('a');
            this.setShowToModalRawMaterials(false);
            this.setShowToModalRawMaterial(true);
        },
        async openModalForEdition(raw_material) {
            await this.getRawMaterial(raw_material);
            this.setActionRawMaterialShow('Editar');
            this.setStepToModalWizard(0);
            this.setShowToModalWizard(true);
        },
        openModalForCreation() {
            this.resetRawMaterial();
            this.setActionToModalRawMaterial('c');
            this.setShowToModalRawMaterials(false);
            this.setShowToModalRawMaterial(true);
        }
    }
};

</script>

<style lang="scss">
.raw_materials {
    .table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .table thead tr:first-child th:first-child {
        border-top-left-radius: 0.3rem;
    }

    .table thead tr:first-child th:last-child {
        border-top-right-radius: 0.3rem;
    }

    .table td,
    .table th {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .table-selected {
        background-color: #f5f5f5;
        transition: 0.2s;
    }

    .table-white {
        background-color: #ffffff;
        transition: 0.2s;
    }

    .table-selected:hover, .table-white:hover {
        background-color: #dddddd;
    }

    .table-selected .table th, .table-selected .table td {

    }
}
</style>
